"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTripLocation = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const LocationPosition_1 = require("../models/LocationPosition");
let CustomTripLocation = class CustomTripLocation {
    constructor(init) {
        if (init) {
            Object.assign(this, init);
        }
    }
    name;
    position;
    locationId;
    duration;
    countryIsoCode;
    isValid() {
        return !!this.name && this.name.length > 2 && !!this.position;
    }
};
exports.CustomTripLocation = CustomTripLocation;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripLocation.prototype, "name", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocationPosition_1.LocationPosition)
], CustomTripLocation.prototype, "position", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripLocation.prototype, "locationId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CustomTripLocation.prototype, "duration", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], CustomTripLocation.prototype, "countryIsoCode", void 0);
exports.CustomTripLocation = CustomTripLocation = __decorate([
    (0, type_graphql_1.InputType)("CustomTripLocationInput"),
    (0, type_graphql_1.ObjectType)("CustomTripLocation"),
    __metadata("design:paramtypes", [Object])
], CustomTripLocation);
//# sourceMappingURL=CustomTripLocation.js.map